class ContactController {
  constructor(helperService) {
    'ngInject';

    Object.assign(this, { helperService });
  }

  sendForm() {
    const email = `
User name: ${this.name}
User email: ${this.email}
Subject: ${this.subject}
Message: ${this.message}
    `;
    this.helperService.sendEmail({
      recipient_email: this.email,
      subject: this.subject,
      message: email,
    })
      .then(data => {
        console.log(1);
      });
  }
}

export default ContactController;



// WEBPACK FOOTER //
// ./client/app/modules/site/contact/contact.controller.js